<script setup>
const props = defineProps({
  center: {
    default: true,
    required: false,
  },
})
</script>

<template>
  <div
    class="loading-indicator"
    :class="{ 'loading-indicator--center': props.center }"
  />
</template>

<style lang="scss" scoped>
.loading-indicator {
  position: relative;
  border-style: solid;
  border-color: rgba(255, 255, 255, 1) rgba(128, 128, 128, 0.2) rgba(128, 128, 128, 0.2) rgba(128, 128, 128, 0.2);
  border-radius: 50%;
  animation: 600ms linear 0s infinite normal none running loading-indicator;
  width: 30px;
  height: 30px;
  border-width: 4px;
  &--center {
    margin-left: auto;
    margin-right: auto;
  }
}

@keyframes loading-indicator {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.loading-indicator-small {
  width: 20px;
  height: 20px;
  border-width: 3px;
}

.loading-indicator-extra-small {
  width: 14px;
  height: 14px;
  border-width: 2px;
}
</style>
